
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './suggest-explanation';
const mainimage = '/Images/advice.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "suggest" },
];


const Suggest = () => (
  <GrammarPageLayout
    level="B1"
    title="Suggest, Recommend, Offer, Promise"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Suggest and Recommend Exercises"
    seoDescription="Give advice, make offers and commit to actions with suggest, recommend, offer and promise. B1 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default Suggest;
